import { render } from "./Demoscene.vue?vue&type=template&id=e8dfaf30"
import script from "./Demoscene.vue?vue&type=script&lang=js"
export * from "./Demoscene.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__